import { Component, Input, OnInit } from '@angular/core';

/**
 * @deprecated Use `libs/shared/ui/skeleton` instead
 */
@Component({
  selector: 'fz-loading-component',
  templateUrl: './loading-component.component.html',
  styleUrls: ['./loading-component.component.scss'],
})
export class LoadingComponentComponent implements OnInit {
  @Input()
  total: number;

  @Input()
  type: string;

  cards: number[] = [];

  ngOnInit() {
    for (let i = 0; i < this.total; i++) {
      this.cards.push(i);
    }
  }
}
